console.log("home-products.js ok");

(() => {
  const norm = (s) => (s ?? "").toString().trim();

  const parseCardData = (card) => {
    const el = card.querySelector("script.product-data");
    if (!el) return null;

    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      console.warn("[HP] JSON inválido en script.product-data", e);
      return null;
    }
  };

  const closeAllSelects = (card, except = null) => {
    card.querySelectorAll(".hp-select.is-open").forEach((s) => {
      if (s !== except) s.classList.remove("is-open");
    });
  };

  const markSelectedInDropdown = (selectEl) => {
    const current = norm(selectEl.querySelector(".hp-select__value")?.textContent);
    selectEl.querySelectorAll(".hp-select__dropdown li").forEach((li) => {
      li.classList.toggle("is-selected", norm(li.dataset.value) === current);
    });
  };

  const getSelectedOptions = (card) => {
    return Array.from(card.querySelectorAll(".hp-select[data-select]"))
      .map((s) => norm(s.querySelector(".hp-select__value")?.textContent))
      .filter(Boolean);
  };

  const updateVariantLineFromSelected = (card) => {
    const variantEl = card.querySelector(".home-product-card__variant");
    if (!variantEl) return;

    const selected = getSelectedOptions(card);
    variantEl.textContent = selected.join(" — ");
  };

  const findVariant = (variants, selectedOptions) => {
    if (!Array.isArray(variants) || !selectedOptions?.length) return null;

    const target = selectedOptions.map(norm);

    return variants.find((x) => {
      const opts = [x.option1, x.option2, x.option3]
        .filter(Boolean)
        .map(norm);

      return (
        opts.length === target.length &&
        opts.every((o, i) => o === target[i])
      );
    }) || null;
  };

  const getVariantImageSrc = (variant) => {
    if (variant?.featured_image?.src) return variant.featured_image.src;
    if (typeof variant?.featured_image === "string") return variant.featured_image;
    if (variant?.featured_media?.preview_image?.src) {
      return variant.featured_media.preview_image.src;
    }
    return null;
  };

  const formatMoney = (cents) => {
    const value = Number(cents || 0) / 100;

    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR"
    }).format(value);
  };

  const updateImage = (card, variant) => {
    const img = card.querySelector(".home-product-card__img");
    if (!img) return;

    const src = getVariantImageSrc(variant);
    if (!src) return;

    img.setAttribute("src", src);
    img.removeAttribute("srcset");
    img.removeAttribute("sizes");
  };

  const updateAmazonButton = (card, variant) => {
    const btn = card.querySelector(".home-product-card__btn");
    if (!btn || !variant) return;

    const dataEl = card.querySelector(
      `.variant-amazon-data[data-variant-id="${variant.id}"]`
    );

    if (dataEl) {
      const newUrl = dataEl.dataset.url;
      if (newUrl) {
        btn.href = newUrl;
        btn.style.display = "";
      } else {
        btn.style.display = "none";
      }
    }
  };

  const updatePrice = (card, variant) => {
    if (!variant) return;

    const priceEl = card.querySelector(".home-product-card__current");
    const compareEl = card.querySelector(".home-product-card__compare");

    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
    }

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = "";
      } else {
        compareEl.style.display = "none";
      }
    }
  };

  const updateCardFromSelection = (card, data) => {
    updateVariantLineFromSelected(card);

    if (!data?.variants) return;

    const selected = getSelectedOptions(card);
    const variant = findVariant(data.variants, selected);

    if (!variant) return;

    updateImage(card, variant);
    updateAmazonButton(card, variant);
    updatePrice(card, variant);
  };

  const initCard = (card) => {
    const data = parseCardData(card);

    card
      .querySelectorAll(".hp-select[data-select]")
      .forEach((s) => markSelectedInDropdown(s));

    updateCardFromSelection(card, data);

    card.addEventListener("click", (e) => {
      const li = e.target.closest(".hp-select__dropdown li");
      const selectEl = e.target.closest(".hp-select[data-select]");

      if (li && selectEl && card.contains(selectEl)) {
        e.preventDefault();
        e.stopPropagation();

        const value = norm(li.dataset.value);
        const valueEl = selectEl.querySelector(".hp-select__value");
        if (valueEl) valueEl.textContent = value;

        markSelectedInDropdown(selectEl);
        selectEl.classList.remove("is-open");

        updateCardFromSelection(card, data);
        return;
      }

      if (selectEl && card.contains(selectEl)) {
        const isOpen = selectEl.classList.contains("is-open");
        closeAllSelects(card, selectEl);
        selectEl.classList.toggle("is-open", !isOpen);
        if (!isOpen) markSelectedInDropdown(selectEl);
        return;
      }
    });

    document.addEventListener("click", (e) => {
      if (!card.contains(e.target)) closeAllSelects(card);
    });
  };

  const init = () => {
    document.querySelectorAll(".home-product-card-wrap").forEach(initCard);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();